import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import { CircularProgress, FormControl, FormLabel } from '@mui/material';
import { t } from 'i18next';
import { autoCompleteSxProps } from './BakeasyAutoComplete';
import { Fragment, useEffect, useState } from 'react';
import i18n from '../../languages/languages';

interface BakeasySelectAutoCompleteProps {
  key?: any;
  inputValue?: string;
  options?: {}[];
  value?: string;
  label?: string;
  disabled?: boolean;
  values?: string | undefined;
  multiple?: boolean;
  onChange: (newValue: any) => void;
  required?: boolean;
  placeholder?: string;
}

function sleep(duration: number): Promise<void> {
  return new Promise<void>((resolve) => {
    setTimeout(() => {
      resolve();
    }, duration);
  });
}

export function BakeasySelectAutoCompleteCategoryA(
  props: BakeasySelectAutoCompleteProps
) {
  const [open, setOpen] = useState(false);
  const [options, setOptions] = useState<any>(props?.options);
  const loading = open && options?.length === 0;

  useEffect(() => {
    let active = true;

    if (!loading) {
      return undefined;
    }

    (async () => {
      await sleep(1e3 / 2);

      if (active) {
        setOptions(props?.options);
      }
    })();

    return () => {
      active = false;
    };
  }, [loading]);

  useEffect(() => {
    if (!open) {
      setOptions([]);
    }
  }, [open]);

  useEffect(() => {
    if (props?.options && props?.options?.length > 0) {
      setOptions(props?.options);
    }
  }, [props?.options]);

  return (
    <Fragment>
      <FormControl sx={{ minWidth: 120 }} fullWidth={true}>
        <FormLabel sx={{ fontWeight: 600, fontSize: 15, marginBottom: 0.5 }}>
          {props?.label ? t(props.label) : t('CATEGORY')}
          {' *'}
        </FormLabel>
        <Autocomplete
          size="small"
          value={props.value || null}
          disabled={props?.disabled ?? false}
          sx={autoCompleteSxProps}
          id="asynchronous-demo"
          open={open}
          onOpen={() => {
            setOpen(true);
          }}
          onClose={() => {
            setOpen(false);
          }}
          isOptionEqualToValue={(option: any, value: any) => {
            return option?.categoryName === value?.categoryName;
          }}
          getOptionLabel={(option: any) => {
            return option?.categoryName;
          }}
          options={options}
          loading={loading}
          renderInput={(params: any) => {
            return (
              <TextField
                {...params}
                placeholder={t('SELECT_CATEGORY')}
                InputProps={{
                  ...params.InputProps,
                  endAdornment: (
                    <Fragment>
                      {loading ? (
                        <CircularProgress color="inherit" size={20} />
                      ) : null}
                      {params.InputProps.endAdornment}
                    </Fragment>
                  ),
                }}
              />
            );
          }}
          onInputChange={(event: any, value: any) => {
            if (typeof value === 'string' && value?.length > 2) {
              props?.onChange(value);
            }
          }}
          onChange={(event, newValue) => {
            if (typeof newValue === 'object') {
              props?.onChange(newValue);
            }
          }}
        />
      </FormControl>
    </Fragment>
  );
}

// export function BakeasySelectAutoCompleteSubCategory(props: BakeasySelectAutoCompleteProps) {
//   const [open, setOpen] = useState(false);
//   const [options, setOptions] = useState<any>(props?.options);
//   const loading = open && options.length === 0;

//   useEffect(() => {
//     let active = true;

//     if (!loading) {
//       return undefined;
//     }

//     (async () => {
//       await sleep(1e3 / 2);
//       if (active) {
//         setOptions(props?.options);
//       }
//     })();

//     return () => {
//       active = false;
//     };
//   }, [loading]);

//   useEffect(() => {
//     if (!open) {
//       setOptions([]);
//     }
//   }, [open]);

//   useEffect(() => {
//     if (props?.options && props?.options?.length > 0) {
//       setOptions(props?.options);
//     }
//   }, [props?.options]);

//   return (
//     <FormControl sx={{ minWidth: 120 }} fullWidth={true} disabled={false}>
//       <FormLabel sx={{ fontWeight: 600, fontSize: 15, marginBottom: 0.5 }}>
//         {props?.label ? t(props.label) : t('SUBCATEGORY')}
//         {' *'}
//       </FormLabel>
//       <Autocomplete
//         size="small"
//         value={props.value || null}
//         disabled={props?.disabled ?? false}
//         sx={autoCompleteSxProps}
//         id="asynchronous-demo"
//         open={open}
//         onOpen={() => {
//           setOpen(true);
//         }}
//         onClose={() => {
//           setOpen(false);
//         }}
//         isOptionEqualToValue={(option: any, value: any) => {
//           return option?.subCategoryName === value?.subCategoryName;
//         }}
//         getOptionLabel={(option: any) => {
//           return option?.subCategoryName;
//         }}
//         options={options}
//         loading={loading}
//         renderInput={params => {
//           return (
//             <TextField
//               {...params}
//               placeholder={t('SELECT') + t('SUB_CATEGORY')}
//               InputProps={{
//                 ...params.InputProps,
//                 endAdornment: (
//                   <Fragment>
//                     {loading ? <CircularProgress color="inherit" size={20} /> : null}
//                     {params.InputProps.endAdornment}
//                   </Fragment>
//                 )
//               }}
//             />
//           );
//         }}
//         onInputChange={(event: any, value: any) => {
//           if (typeof value === 'string' && value?.length > 2) {
//             props?.onChange(value);
//           }
//         }}
//         onChange={(event, newValue) => {
//           if (typeof newValue === 'object') {
//             props?.onChange(newValue);
//           }
//         }}
//       />
//     </FormControl>
//   );
// }

export function BakeasySelectAutoCompleteProduct(
  props: BakeasySelectAutoCompleteProps
) {
  const [open, setOpen] = useState(false);
  const [options, setOptions] = useState<any>(props?.options);
  const loading = open && options.length === 0;

  useEffect(() => {
    let active = true;

    if (!loading) {
      return undefined;
    }

    (async () => {
      await sleep(1e3 / 2);

      if (active) {
        setOptions(props?.options);
      }
    })();

    return () => {
      active = false;
    };
  }, [loading]);

  useEffect(() => {
    if (!open) {
      setOptions([]);
    }
  }, [open]);

  useEffect(() => {
    if (props?.options && props?.options?.length > 0) {
      setOptions(props?.options);
    }
  }, [props?.options]);

  return (
    <Fragment>
      <FormControl sx={{ minWidth: 120 }} fullWidth={true}>
        <FormLabel sx={{ fontWeight: 600, fontSize: 15, marginBottom: 0.5 }}>
          {props?.label ? t(props.label) : t('PRODUCT')}
          {' *'}
        </FormLabel>
        <Autocomplete
          size="small"
          value={props.value || null}
          disabled={props?.disabled ?? false}
          sx={autoCompleteSxProps}
          id="asynchronous-demo"
          open={open}
          onOpen={() => {
            setOpen(true);
          }}
          onClose={() => {
            setOpen(false);
          }}
          isOptionEqualToValue={(option: any, value: any) => {
            return option?.productName === value?.productName;
          }}
          getOptionLabel={(option: any) => {
            return option?.productName;
          }}
          options={options}
          loading={loading}
          renderInput={(params: any) => {
            return (
              <TextField
                {...params}
                placeholder={t('SELECT_PRODUCT')}
                InputProps={{
                  ...params.InputProps,
                  endAdornment: (
                    <Fragment>
                      {loading ? (
                        <CircularProgress color="inherit" size={20} />
                      ) : null}
                      {params.InputProps.endAdornment}
                    </Fragment>
                  ),
                }}
              />
            );
          }}
          onInputChange={(event: any, value: any) => {
            if (typeof value === 'string' && value?.length > 2) {
              props?.onChange(value);
            }
          }}
          onChange={(event, newValue) => {
            if (typeof newValue === 'object') {
              props?.onChange(newValue);
            }
          }}
        />
      </FormControl>
    </Fragment>
  );
}

export function BakeasySelectAutoCompleteStore(
  props: BakeasySelectAutoCompleteProps
) {
  const [open, setOpen] = useState(false);
  const [options, setOptions] = useState<any>(props?.options);
  const loading = open && options.length === 0;

  useEffect(() => {
    let active = true;

    if (!loading) {
      return undefined;
    }

    (async () => {
      await sleep(1e3 / 2);

      if (active) {
        setOptions(props?.options);
      }
    })();

    return () => {
      active = false;
    };
  }, [loading]);

  useEffect(() => {
    if (!open) {
      setOptions([]);
    }
  }, [open]);

  useEffect(() => {
    if (props?.options && props?.options?.length > 0) {
      setOptions(props?.options);
    }
  }, [props?.options]);

  return (
    <Fragment>
      <FormControl sx={{ minWidth: 120 }} fullWidth={true}>
        <FormLabel sx={{ fontWeight: 600, fontSize: 15, marginBottom: 0.5 }}>
          {props?.label ? t(props.label) : t('STORE')}
          {' *'}
        </FormLabel>
        <Autocomplete
          size="small"
          value={props.value || null}
          disabled={props?.disabled ?? false}
          sx={autoCompleteSxProps}
          id="asynchronous-demo"
          open={open}
          onOpen={() => {
            setOpen(true);
          }}
          onClose={() => {
            setOpen(false);
          }}
          isOptionEqualToValue={(option: any, value: any) => {
            return option?.storeName === value?.storeName;
          }}
          getOptionLabel={(option: any) => {
            return option?.storeName;
          }}
          options={options}
          loading={loading}
          renderInput={(params: any) => {
            return (
              <TextField
                {...params}
                placeholder={t('SELECT_STORE')}
                InputProps={{
                  ...params.InputProps,
                  endAdornment: (
                    <Fragment>
                      {loading ? (
                        <CircularProgress color="inherit" size={20} />
                      ) : null}
                      {params.InputProps.endAdornment}
                    </Fragment>
                  ),
                }}
              />
            );
            //}
          }}
          onInputChange={(event: any, value: any) => {
            if (typeof value === 'string' && value?.length > 2) {
              props?.onChange(value);
            }
          }}
          onChange={(event, newValue) => {
            if (typeof newValue === 'object') {
              props?.onChange(newValue);
            }
          }}
        />
      </FormControl>
    </Fragment>
  );
}

export function BakeasySelectAutoCompleteSupplier(
  props: BakeasySelectAutoCompleteProps
) {
  const [open, setOpen] = useState(false);
  const [options, setOptions] = useState<any>(props?.options);
  const loading = open && options.length === 0;

  useEffect(() => {
    let active = true;

    if (!loading) {
      return undefined;
    }

    (async () => {
      await sleep(1e3 / 2);

      if (active) {
        setOptions(props?.options);
      }
    })();

    return () => {
      active = false;
    };
  }, [loading]);

  useEffect(() => {
    if (!open) {
      setOptions([]);
    }
  }, [open]);

  useEffect(() => {
    if (props?.options && props?.options?.length > 0) {
      setOptions(props?.options);
    }
  }, [props?.options]);

  return (
    <Fragment>
      <FormControl sx={{ minWidth: 120 }} fullWidth={true}>
        <FormLabel sx={{ fontWeight: 600, fontSize: 15, marginBottom: 0.5 }}>
          {props?.label ? t(props.label) : t('SUPPLIER')}
          {' *'}
        </FormLabel>
        <Autocomplete
          size="small"
          value={props.value || null}
          disabled={props?.disabled ?? false}
          sx={autoCompleteSxProps}
          id="asynchronous-demo"
          open={open}
          onOpen={() => {
            setOpen(true);
          }}
          onClose={() => {
            setOpen(false);
          }}
          isOptionEqualToValue={(option: any, value: any) => {
            return option?.supplierName === value?.supplierName;
          }}
          getOptionLabel={(option: any) => {
            return option?.supplierName;
          }}
          options={options}
          loading={loading}
          renderInput={(params: any) => {
            return (
              <TextField
                {...params}
                placeholder={t('SELECT_SUPPLIER')}
                InputProps={{
                  ...params.InputProps,
                  endAdornment: (
                    <Fragment>
                      {loading ? (
                        <CircularProgress color="inherit" size={20} />
                      ) : null}
                      {params.InputProps.endAdornment}
                    </Fragment>
                  ),
                }}
              />
            );
            //}
          }}
          onInputChange={(event: any, value: any) => {
            if (typeof value === 'string' && value?.length > 2) {
              props?.onChange(value);
            }
          }}
          onChange={(event, newValue) => {
            if (typeof newValue === 'object') {
              props?.onChange(newValue);
            }
          }}
        />
      </FormControl>
    </Fragment>
  );
}

export function BakeasySelectAutoCompleteStates(
  props: BakeasySelectAutoCompleteProps
) {
  const [open, setOpen] = useState(false);
  const [options, setOptions] = useState<any>(props?.options ?? []);
  const loading = open && options.length === 0;

  useEffect(() => {
    let active = true;

    if (!loading) {
      return undefined;
    }

    (async () => {
      await sleep(1e3 / 2);

      if (active) {
        setOptions(props?.options);
      }
    })();

    return () => {
      active = false;
    };
  }, [loading]);

  useEffect(() => {
    if (!open) {
      setOptions([]);
    }
  }, [open]);

  useEffect(() => {
    if (props?.options && props?.options?.length > 0) {
      setOptions(props?.options);
    }
  }, [props?.options]);

  return (
    <Fragment>
      <FormControl sx={{ minWidth: 120 }} fullWidth={true}>
        <FormLabel sx={{ fontWeight: 600, fontSize: 15, marginBottom: 0.5 }}>
          {props?.label ? t(props.label) : t('STATE')}
        </FormLabel>
        <Autocomplete
          size="small"
          value={props.value || null}
          disabled={props?.disabled ?? false}
          sx={autoCompleteSxProps}
          id="asynchronous-demo"
          open={open}
          onOpen={() => {
            setOpen(true);
          }}
          onClose={() => {
            setOpen(false);
          }}
          isOptionEqualToValue={(option: any, value: any) => {
            if (typeof option === 'string') {
              return true;
            }
            return option?.stateName === value?.stateName;
          }}
          // getOptionLabel={(option: any) => {
          //   if (typeof option === 'string') {
          //     return option;
          //   }
          //   return option?.stateName;
          // }}
          getOptionLabel={(option: any) => {
            if (!option) return '';
            const key = `${option?.toUpperCase()?.replace(/\s+/g, '_')}`;
            const translation = t(key);
            return translation === key ? option : translation;
          }}
          options={options}
          loading={loading}
          renderInput={(params: any) => {
            return (
              <TextField
                {...params}
                placeholder={t('SELECT_STATE')}
                InputProps={{
                  ...params.InputProps,
                  endAdornment: (
                    <Fragment>
                      {loading ? (
                        <CircularProgress color="inherit" size={20} />
                      ) : null}
                      {params.InputProps.endAdornment}
                    </Fragment>
                  ),
                }}
              />
            );
          }}
          onInputChange={(event: any, value: any) => {
            props?.onChange(value);
          }}
          onChange={(event, newValue) => {
            props?.onChange(newValue);
          }}
        />
      </FormControl>
    </Fragment>
  );
}

export function BakeasySelectAutoCompleteCities(
  props: BakeasySelectAutoCompleteProps
) {
  const [open, setOpen] = useState(false);
  const [options, setOptions] = useState<any>(props?.options ?? []);
  const loading = open && options.length === 0;

  useEffect(() => {
    let active = true;

    if (!loading) {
      return undefined;
    }

    (async () => {
      await sleep(1e3 / 2);

      if (active) {
        setOptions(props?.options);
      }
    })();

    return () => {
      active = false;
    };
  }, [loading]);

  useEffect(() => {
    if (!open) {
      setOptions([]);
    }
  }, [open]);

  useEffect(() => {
    if (props?.options && props?.options?.length > 0) {
      setOptions(props?.options);
    }
  }, [props?.options]);

  return (
    <Fragment>
      <FormControl sx={{ minWidth: 120 }} fullWidth={true}>
        <FormLabel sx={{ fontWeight: 600, fontSize: 15, marginBottom: 0.5 }}>
          {props?.label ? t(props.label) : t('CITY')}
          {/* {' *'} */}
        </FormLabel>
        <Autocomplete
          size="small"
          value={props.value || null}
          disabled={props?.disabled ?? false}
          sx={autoCompleteSxProps}
          id="asynchronous-demo"
          open={open}
          onOpen={() => {
            setOpen(true);
          }}
          onClose={() => {
            setOpen(false);
          }}
          isOptionEqualToValue={(option: any, value: any) => {
            if (typeof option === 'string') {
              return true;
            }
            return option?.cityName === value?.cityName;
          }}
          getOptionLabel={(option: any) => {
            if (typeof option === 'string') {
              return option;
            }
            return option?.cityName;
          }}
          options={options}
          loading={loading}
          renderInput={(params: any) => {
            return (
              <TextField
                {...params}
                placeholder={t('SELECT_CITY')}
                InputProps={{
                  ...params.InputProps,
                  endAdornment: (
                    <Fragment>
                      {loading ? (
                        <CircularProgress color="inherit" size={20} />
                      ) : null}
                      {params.InputProps.endAdornment}
                    </Fragment>
                  ),
                }}
              />
            );
          }}
          onInputChange={(event: any, value: any) => {
            props?.onChange(value);
          }}
          onChange={(event, newValue) => {
            props?.onChange(newValue);
          }}
        />
      </FormControl>
    </Fragment>
  );
}

export function BakeasySelectAutoCompleteZipcode(
  props: BakeasySelectAutoCompleteProps
) {
  const [open, setOpen] = useState(false);
  const [options, setOptions] = useState<any>(
    props?.options ? props?.options : []
  );
  const loading = open && options.length === 0;

  useEffect(() => {
    let active = true;

    if (!loading) {
      return undefined;
    }

    (async () => {
      await sleep(1e3 / 2);

      if (active) {
        setOptions(props?.options ? props?.options : []);
      }
    })();

    return () => {
      active = false;
    };
  }, [loading]);

  useEffect(() => {
    if (!open) {
      setOptions([]);
    }
  }, [open]);

  useEffect(() => {
    if (props?.options && props?.options?.length > 0) {
      setOptions(props?.options);
    }
  }, [props?.options]);

  return (
    <Fragment>
      <FormControl sx={{ minWidth: 120 }} fullWidth={true}>
        <FormLabel sx={{ fontWeight: 600, fontSize: 15, marginBottom: 0.5 }}>
          {props?.label ? t(props.label) : t('POSTAL_CODE')}
          {/* {' *'} */}
        </FormLabel>
        <Autocomplete
          size="small"
          value={props.value || null}
          disabled={props?.disabled ?? false}
          sx={autoCompleteSxProps}
          id="asynchronous-demo"
          open={open}
          onOpen={() => {
            setOpen(true);
          }}
          onClose={() => {
            setOpen(false);
          }}
          isOptionEqualToValue={(option: any, value: any) => {
            if (typeof option === 'string') {
              return true;
            }
            return option?.cityName === value?.cityName;
          }}
          getOptionLabel={(option: any) => {
            if (typeof option === 'string') {
              return option;
            }
            return option?.cityName;
          }}
          options={options}
          loading={loading}
          renderInput={(params: any) => {
            return (
              <TextField
                {...params}
                placeholder={t('SELECT_POSTAL_CODE')}
                InputProps={{
                  ...params.InputProps,
                  endAdornment: (
                    <Fragment>
                      {loading ? (
                        <CircularProgress color="inherit" size={20} />
                      ) : null}
                      {params.InputProps.endAdornment}
                    </Fragment>
                  ),
                }}
              />
            );
          }}
          onInputChange={(event: any, value: any) => {
            props?.onChange(value);
          }}
          onChange={(event, newValue) => {
            props?.onChange(newValue);
          }}
        />
      </FormControl>
    </Fragment>
  );
}

export function BakeasySelectAutoCompleteMessageFrom(
  props: BakeasySelectAutoCompleteProps
) {
  const [open, setOpen] = useState(false);
  const [options, setOptions] = useState<any>(props?.options);
  const loading = open && options?.length === 0;

  useEffect(() => {
    let active = true;

    if (!loading) {
      return undefined;
    }

    (async () => {
      await sleep(1e3 / 2);

      if (active) {
        setOptions(props?.options);
      }
    })();

    return () => {
      active = false;
    };
  }, [loading]);

  useEffect(() => {
    if (!open) {
      setOptions([]);
    }
  }, [open]);

  useEffect(() => {
    if (props?.options && props?.options?.length > 0) {
      setOptions(props?.options);
    }
  }, [props?.options]);

  return (
    <Fragment>
      <FormControl sx={{ minWidth: 120 }} fullWidth={true}>
        <FormLabel sx={{ fontWeight: 600, fontSize: 15, marginBottom: 0.5 }}>
          {props?.label ? t(props?.label) : t('FROM')}
          {/* {' *'} */}
        </FormLabel>
        <Autocomplete
          multiple={props?.multiple ?? false}
          size="small"
          value={props?.multiple ? props?.values : props?.value}
          disabled={props?.disabled ?? false}
          sx={autoCompleteSxProps}
          id="asynchronous-demo"
          open={open}
          onOpen={() => {
            setOpen(true);
          }}
          onClose={() => {
            setOpen(false);
          }}
          isOptionEqualToValue={(option: any, value: any) => {
            if (typeof option === 'string') {
              return true;
            }
            return option?.name === value?.name;
          }}
          getOptionLabel={(option: any) => {
            if (typeof option === 'string') {
              return option;
            }
            return option?.name;
          }}
          options={options}
          loading={loading}
          renderInput={(params: any) => {
            return (
              <TextField
                {...params}
                placeholder={t('SELECT_FROM')}
                InputProps={{
                  ...params.InputProps,
                  endAdornment: (
                    <Fragment>
                      {loading ? (
                        <CircularProgress color="inherit" size={20} />
                      ) : null}
                      {params.InputProps.endAdornment}
                    </Fragment>
                  ),
                }}
              />
            );
          }}
          onInputChange={(event: any, value: any) => {
            if (
              typeof value === 'string' &&
              (value?.length > 2 || value?.length === 0)
            ) {
              props?.onChange(value);
            }
          }}
          onChange={(event, newValue) => {
            if (typeof newValue === 'object') {
              props?.onChange(newValue);
            }
          }}
        />
      </FormControl>
    </Fragment>
  );
}

export function BakeasySelectAutoCompleteMessageTo(
  props: BakeasySelectAutoCompleteProps
) {
  const [open, setOpen] = useState(false);
  const [options, setOptions] = useState<any>(props?.options);
  const loading = open && options?.length === 0;

  useEffect(() => {
    let active = true;

    if (!loading) {
      return undefined;
    }

    (async () => {
      await sleep(1e3 / 2);

      if (active) {
        setOptions(props?.options);
      }
    })();

    return () => {
      active = false;
    };
  }, [loading]);

  useEffect(() => {
    if (!open) {
      setOptions([]);
    }
  }, [open]);

  useEffect(() => {
    if (props?.options && props?.options?.length > 0) {
      setOptions(props?.options);
    }
  }, [props?.options]);

  return (
    <Fragment>
      <FormControl sx={{ minWidth: 120 }} fullWidth={true}>
        <FormLabel sx={{ fontWeight: 600, fontSize: 15, marginBottom: 0.5 }}>
          {props?.label ? t(props?.label) : t('TO')}
          {/* {' *'} */}
        </FormLabel>
        <Autocomplete
          multiple={props?.multiple ?? false}
          size="small"
          value={props?.multiple ? props?.values : props?.value}
          disabled={props?.disabled ?? false}
          sx={autoCompleteSxProps}
          id="asynchronous-demo"
          open={open}
          onOpen={() => {
            setOpen(true);
          }}
          onClose={() => {
            setOpen(false);
          }}
          isOptionEqualToValue={(option: any, value: any) => {
            if (typeof option === 'string') {
              return true;
            }
            return option?.name === value?.name;
          }}
          getOptionLabel={(option: any) => {
            if (typeof option === 'string') {
              return option;
            }
            return option?.name;
          }}
          options={options}
          loading={loading}
          renderInput={(params: any) => {
            return (
              <TextField
                {...params}
                placeholder={t('SELECT_TO')}
                InputProps={{
                  ...params.InputProps,
                  endAdornment: (
                    <Fragment>
                      {loading ? (
                        <CircularProgress color="inherit" size={20} />
                      ) : null}
                      {params.InputProps.endAdornment}
                    </Fragment>
                  ),
                }}
              />
            );
          }}
          onInputChange={(event: any, value: any) => {
            if (
              typeof value === 'string' &&
              (value?.length > 2 || value?.length === 0)
            ) {
              props?.onChange(value);
            }
          }}
          onChange={(event, newValue) => {
            if (typeof newValue === 'object') {
              props?.onChange(newValue);
            }
          }}
        />
      </FormControl>
    </Fragment>
  );
}

export function BakeasyAutoCompleteCountry(
  props: BakeasySelectAutoCompleteProps
) {
  const [open, setOpen] = useState(false);
  const [options, setOptions] = useState<any>(props?.options ?? []);
  const loading = open && options?.length === 0;

  useEffect(() => {
    let active = true;

    if (!loading) {
      return undefined;
    }

    (async () => {
      await sleep(1e3 / 2);

      if (active) {
        setOptions(props?.options);
      }
    })();

    return () => {
      active = false;
    };
  }, [loading]);

  useEffect(() => {
    if (!open) {
      setOptions([]);
    }
  }, [open]);

  useEffect(() => {
    if (props?.options && props?.options?.length > 0) {
      setOptions(props?.options);
    }
  }, [props?.options]);

  return (
    <Fragment>
      <FormControl sx={{ minWidth: 120 }} fullWidth={true}>
        <FormLabel sx={{ fontWeight: 600, fontSize: 15, marginBottom: 0.5 }}>
          {props?.label ? t(props.label) : t('COUNTRY')}
          {props?.required}
        </FormLabel>
        <Autocomplete
          id={props?.label ? t(props.label) : t('COUNTRY')}
          size="small"
          value={props.value || null}
          disabled={props?.disabled ?? false}
          sx={autoCompleteSxProps}
          open={open}
          onOpen={() => {
            setOpen(true);
          }}
          onClose={() => {
            setOpen(false);
          }}
          isOptionEqualToValue={(option: any, value: any) => {
            return option?.countryName === value?.countryName;
          }}
          // getOptionLabel={(option: any) => {
          //   return t(option?.countryName);
          // }}
          getOptionLabel={(option: any) => {
            if (!option?.countryName) return '';
            const key = `${option.countryName.toUpperCase().replace(/\s+/g, '_')}`;
            const translation = t(key);
            return translation === key ? option.countryName : translation;
          }}
          options={options}
          loading={loading}
          renderInput={(params: any) => {
            return (
              <TextField
                {...params}
                // placeholder={t('SELECT') + t('COUNTRY')}
                placeholder={
                  props.placeholder ? props?.placeholder : t(props?.label || '')
                }
                InputProps={{
                  ...params.InputProps,
                  endAdornment: (
                    <Fragment>
                      {loading ? (
                        <CircularProgress color="inherit" size={20} />
                      ) : null}
                      {params.InputProps.endAdornment}
                    </Fragment>
                  ),
                }}
              />
            );
          }}
          onInputChange={(event: any, value: any) => {
            if (typeof value === 'string' && value?.length > 2) {
              props?.onChange(value);
            }
          }}
          onChange={(event, newValue) => {
            if (typeof newValue === 'object') {
              props?.onChange(newValue);
            }
          }}
        />
      </FormControl>
    </Fragment>
  );
}

export function BakeasyAutoCompleteState(
  props: BakeasySelectAutoCompleteProps
) {
  const [open, setOpen] = useState(false);
  const [options, setOptions] = useState<any>(props?.options ?? []);
  const loading = open && options?.length === 0;
  const getTranslationKey = (stateName: string) => {
    if (!stateName) return '';
    return `STATE_${stateName.toUpperCase().replace(/\s+/g, '_')}`;
  };
  useEffect(() => {
    let active = true;

    if (!loading) {
      return undefined;
    }

    (async () => {
      await sleep(1e3 / 2);
      if (active) {
        setOptions(props?.options);
      }
    })();

    return () => {
      active = false;
    };
  }, [loading]);

  useEffect(() => {
    if (!open) {
      setOptions([]);
    }
  }, [open]);

  useEffect(() => {
    if (props?.options && props?.options?.length > 0) {
      setOptions(props?.options);
    }
  }, [props?.options]);

  return (
    <FormControl sx={{ minWidth: 120 }} fullWidth={true} disabled={false}>
      <FormLabel sx={{ fontWeight: 600, fontSize: 15, marginBottom: 0.5 }}>
        {props?.label ? t(props.label) : t('STATE')}
        {props?.required}
      </FormLabel>
      <Autocomplete
        id={props?.label ? t(props.label) : t('STATE')}
        size="small"
        value={props.value || null}
        disabled={props?.disabled ?? false}
        sx={autoCompleteSxProps}
        open={open}
        onOpen={() => {
          setOpen(true);
        }}
        onClose={() => {
          setOpen(false);
        }}
        isOptionEqualToValue={(option: any, value: any) => {
          return option?.stateName === value?.stateName;
        }}
        getOptionLabel={(option: any) => {
          if (!option?.stateName) return '';
          const key = `${option.stateName.toUpperCase().replace(/\s+/g, '_')}`;
          const translation = t(key);
          return translation === key ? option.stateName : translation;
        }}
        options={options}
        loading={loading}
        renderInput={(params) => {
          return (
            <TextField
              {...params}
              placeholder={
                props.placeholder ? props?.placeholder : t(props?.label || '')
              }
              InputProps={{
                ...params.InputProps,
                endAdornment: (
                  <Fragment>
                    {loading ? (
                      <CircularProgress color="inherit" size={20} />
                    ) : null}
                    {params.InputProps.endAdornment}
                  </Fragment>
                ),
              }}
            />
          );
        }}
        onInputChange={(event: any, value: any) => {
          if (typeof value === 'string' && value?.length > 2) {
            props?.onChange(value);
          }
        }}
        onChange={(event, newValue) => {
          if (typeof newValue === 'object') {
            props?.onChange(newValue);
          }
        }}
      />
    </FormControl>
  );
}

export function BakeasyAutoCompletePaymentMethod(
  props: BakeasySelectAutoCompleteProps
) {
  const [open, setOpen] = useState(false);
  const [options, setOptions] = useState<any>(props?.options ?? []);
  const loading = open && options?.length === 0;

  useEffect(() => {
    let active = true;

    if (!loading) {
      return undefined;
    }

    (async () => {
      //await sleep(1e3 / 2);
      if (active) {
        setOptions(props?.options);
      }
    })();

    return () => {
      active = false;
    };
  }, [loading]);

  useEffect(() => {
    if (!open) {
      setOptions([]);
    }
  }, [open]);

  useEffect(() => {
    if (props?.options && props?.options?.length > 0) {
      setOptions(props?.options);
    }
  }, [props?.options]);

  return (
    <FormControl sx={{ minWidth: 120 }} fullWidth={true} disabled={false}>
      <FormLabel sx={{ fontWeight: 600, fontSize: 15, marginBottom: 0.5 }}>
        {props?.label ? t(props.label) : t('METHOD')}
        {props?.required ? ' *' : ''}
      </FormLabel>
      <Autocomplete
        id={props?.label ? t(props.label) : t('METHOD')}
        size="small"
        value={props.value || null}
        disabled={props?.disabled ?? false}
        sx={autoCompleteSxProps}
        open={open}
        onOpen={() => {
          setOpen(true);
        }}
        onClose={() => {
          setOpen(false);
        }}
        // isOptionEqualToValue={(option: any, value: any) => {
        //   return option?.paymentMethod[i18n.language] === value?.paymentMethod[i18n.language];
        // }}
        // getOptionLabel={(option: any) => {
        //   return option?.paymentMethod[i18n.language];
        // }}
        isOptionEqualToValue={(option: any, value: any) => {
          return (
            option?.paymentMethod[i18n.language] ===
            value?.paymentMethod[i18n.language]
          );
        }}
        getOptionLabel={(option: any) => {
          return t(option?.paymentMethod[i18n.language]);
        }}
        options={options}
        loading={loading}
        renderInput={(params) => {
          return (
            <TextField
              {...params}
              placeholder={
                props.placeholder ? props?.placeholder : t(props?.label || '')
              }
              InputProps={{
                ...params.InputProps,
                endAdornment: (
                  <Fragment>
                    {loading ? (
                      <CircularProgress color="inherit" size={20} />
                    ) : null}
                    {params.InputProps.endAdornment}
                  </Fragment>
                ),
              }}
            />
          );
        }}
        onInputChange={(event: any, value: any) => {
          if (typeof value === 'string' && value?.length > 2) {
            props?.onChange(value);
          }
        }}
        onChange={(event, newValue) => {
          if (typeof newValue === 'object') {
            props?.onChange(newValue);
          }
        }}
      />
    </FormControl>
  );
}

export function BakeasyAutoCompletePaymentTerms(
  props: BakeasySelectAutoCompleteProps
) {
  const [open, setOpen] = useState(false);
  const [options, setOptions] = useState<any>(props?.options ?? []);
  const loading = open && options?.length === 0;

  useEffect(() => {
    let active = true;

    if (!loading) {
      return undefined;
    }

    (async () => {
      //await sleep(1e3 / 2);
      if (active) {
        setOptions(props?.options);
      }
    })();

    return () => {
      active = false;
    };
  }, [loading]);

  useEffect(() => {
    if (!open) {
      setOptions([]);
    }
  }, [open]);

  useEffect(() => {
    if (props?.options && props?.options?.length > 0) {
      setOptions(props?.options);
    }
  }, [props?.options]);

  return (
    <FormControl sx={{ minWidth: 120 }} fullWidth={true} disabled={false}>
      <FormLabel sx={{ fontWeight: 600, fontSize: 15, marginBottom: 0.5 }}>
        {props?.label ? t(props.label) : t('TERMS')}
        {props?.required ? ' *' : ''}
      </FormLabel>
      <Autocomplete
        id={props?.label ? t(props.label) : t('TERMS')}
        size="small"
        value={props.value || null}
        disabled={props?.disabled ?? false}
        sx={autoCompleteSxProps}
        open={open}
        onOpen={() => {
          setOpen(true);
        }}
        onClose={() => {
          setOpen(false);
        }}
        isOptionEqualToValue={(option: any, value: any) => {
          return (
            option?.paymentTerms?.[i18n.language] ===
            value?.paymentTerms?.[i18n.language]
          );
        }}
        getOptionLabel={(option: any) => {
          return option?.paymentTerms[i18n.language];
        }}
        options={options}
        loading={loading}
        renderInput={(params) => {
          return (
            <TextField
              {...params}
              placeholder={
                props.placeholder ? props?.placeholder : t(props?.label || '')
              }
              InputProps={{
                ...params.InputProps,
                endAdornment: (
                  <Fragment>
                    {loading ? (
                      <CircularProgress color="inherit" size={20} />
                    ) : null}
                    {params.InputProps.endAdornment}
                  </Fragment>
                ),
              }}
            />
          );
        }}
        onInputChange={(event: any, value: any) => {
          if (typeof value === 'string' && value?.length > 2) {
            props?.onChange(value);
          }
        }}
        onChange={(event, newValue) => {
          if (typeof newValue === 'object') {
            props?.onChange(newValue);
          }
        }}
      />
    </FormControl>
  );
}

export function BakeasyAutoCompleteSetupFee(
  props: BakeasySelectAutoCompleteProps
) {
  const [open, setOpen] = useState(false);
  const [options, setOptions] = useState<any>(props?.options ?? []);
  const loading = open && options?.length === 0;

  useEffect(() => {
    let active = true;

    if (!loading) {
      return undefined;
    }

    (async () => {
      if (active) {
        setOptions(props?.options);
      }
    })();

    return () => {
      active = false;
    };
  }, [loading]);

  useEffect(() => {
    if (!open) {
      setOptions([]);
    }
  }, [open]);

  useEffect(() => {
    if (props?.options && props?.options?.length > 0) {
      setOptions(props?.options);
    }
  }, [props?.options]);

  return (
    <FormControl sx={{ minWidth: 120 }} fullWidth={true} disabled={false}>
      <FormLabel sx={{ fontWeight: 600, fontSize: 15, marginBottom: 0.5 }}>
        {props?.label ? t(props.label) : t('SETUP_FEE')}
        {props?.required ? ' *' : ''}
      </FormLabel>
      <Autocomplete
        id={props?.label ? t(props.label) : t('SETUP_FEES')}
        size="small"
        value={props.value || null}
        disabled={props?.disabled ?? false}
        sx={autoCompleteSxProps}
        open={open}
        onOpen={() => {
          setOpen(true);
        }}
        onClose={() => {
          setOpen(false);
        }}
        isOptionEqualToValue={(option: any, value: any) => {
          return (
            option?.setupFee?.[i18n.language] ===
            value?.setupFee?.[i18n.language]
          );
        }}
        getOptionLabel={(option: any) => {
          return option?.setupFee[i18n.language];
        }}
        options={options}
        loading={loading}
        renderInput={(params) => {
          return (
            <TextField
              {...params}
              placeholder={
                props.placeholder ? props?.placeholder : t(props?.label || '')
              }
              InputProps={{
                ...params.InputProps,
                endAdornment: (
                  <Fragment>
                    {loading ? (
                      <CircularProgress color="inherit" size={20} />
                    ) : null}
                    {params.InputProps.endAdornment}
                  </Fragment>
                ),
              }}
            />
          );
        }}
        onInputChange={(event: any, value: any) => {
          if (typeof value === 'string' && value?.length > 2) {
            props?.onChange(value);
          }
        }}
        onChange={(event, newValue) => {
          if (typeof newValue === 'object') {
            props?.onChange(newValue);
          }
        }}
      />
    </FormControl>
  );
}

export function BakeasyAutoCompleteSubscriptionPack(
  props: BakeasySelectAutoCompleteProps
) {
  const [open, setOpen] = useState(false);
  const [options, setOptions] = useState<any>(props?.options ?? []);
  const loading = open && options?.length === 0;

  useEffect(() => {
    let active = true;

    if (!loading) {
      return undefined;
    }

    (async () => {
      if (active) {
        setOptions(props?.options);
      }
    })();

    return () => {
      active = false;
    };
  }, [loading]);

  useEffect(() => {
    if (!open) {
      setOptions([]);
    }
  }, [open]);

  useEffect(() => {
    if (props?.options && props?.options?.length > 0) {
      setOptions(props?.options);
    }
  }, [props?.options]);

  return (
    <FormControl sx={{ minWidth: 120 }} fullWidth={true} disabled={false}>
      <FormLabel sx={{ fontWeight: 600, fontSize: 15, marginBottom: 0.5 }}>
        {props?.label ? t(props.label) : t('SUBSCRIPTION_PACK')}
        {props?.required ? ' *' : ''}
      </FormLabel>
      <Autocomplete
        id={props?.label ? t(props.label) : t('SUBSCRIPTION_PACK')}
        size="small"
        value={props.value || null}
        disabled={props?.disabled ?? false}
        sx={autoCompleteSxProps}
        open={open}
        onOpen={() => {
          setOpen(true);
        }}
        onClose={() => {
          setOpen(false);
        }}
        isOptionEqualToValue={(option: any, value: any) => {
          return (
            option?.subscriptionPack?.[i18n.language] ===
            value?.subscriptionPack?.[i18n.language]
          );
        }}
        getOptionLabel={(option: any) => {
          return option?.subscriptionPack[i18n.language];
        }}
        options={options}
        loading={loading}
        renderInput={(params) => {
          return (
            <TextField
              {...params}
              placeholder={
                props.placeholder ? props?.placeholder : t(props?.label || '')
              }
              InputProps={{
                ...params.InputProps,
                endAdornment: (
                  <Fragment>
                    {loading ? (
                      <CircularProgress color="inherit" size={20} />
                    ) : null}
                    {params.InputProps.endAdornment}
                  </Fragment>
                ),
              }}
            />
          );
        }}
        onInputChange={(event: any, value: any) => {
          if (typeof value === 'string' && value?.length > 2) {
            props?.onChange(value);
          }
        }}
        onChange={(event, newValue) => {
          if (typeof newValue === 'object') {
            props?.onChange(newValue);
          }
        }}
      />
    </FormControl>
  );
}
